<template>
  <b-card
    no-body
    class="mb-0"
  >
    <div class="m-2">
      <div class="content-box mb-2">
        <div class="selet-box">
          <b-row>
            <b-col cols="12" md="4">
              <el-input
                v-model="insetName"
                style="width: 100%"
                placeholder="输入岗位名称查询"
              />
            </b-col>
            <b-col cols="12" md="4">
              <el-date-picker
                v-model="chooseMonth"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择月"
                style="width: 100%"
              />
            </b-col>
            <b-col cols="12" md="4" align="right">
              <el-button
                type="primary"
                @click="initPage"
              >查询</el-button>
            </b-col>
          </b-row>
        </div>
        <div>
          <el-table
            :data="tableData"
            class="responsive"
          >
            <el-table-responsive-column
              type="index"
              label="序号"
              width="60"
            />
            <el-table-responsive-column
              prop="jobName"
              label="岗位名称"
            />
            <el-table-responsive-column
              prop="unitName"
              label="设岗单位"
            />
            <el-table-responsive-column
              prop="yearMonthStr"
              label="考核年月"
            />
            <el-table-responsive-column
              prop="timeStr"
              label="工作时间段"
            />
            <el-table-responsive-column
              prop="realMoney"
              label="实际发放工资"
            />
            <el-table-responsive-column
              prop="updateDate"
              label="审核完成时间"
            />
          </el-table>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { salaryService } from '@/api/index'
import { checkName } from '@/tool/utils'

export default {
  name: 'Index',
  data() {
    return {
      insetName: '',
      chooseMonth: null,
      tableData: [],
    }
  },
  created() {
    this.chooseMonth = this.$moment().subtract(0, 'month').format('YYYY-MM')
    this.initPage()
  },
  methods: {
    initPage() {
      const params = {
        jobName: this.insetName,
        time: this.chooseMonth,
      }
      if (!checkName(this.insetName)) {
        salaryService()._studentHistorySalaryList(params).then(res => {
          this.tableData = res.data.list
        })
      } else {
        this.$message.warning('请输入正确单位或岗位名称')
      }
    },
  },
}
</script>

<style scoped>
</style>
